"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RRCouponBlockReason = exports.RRCouponStatus = void 0;
class Order {
}
exports.default = Order;
// RR Coupon
var RRCouponStatus;
(function (RRCouponStatus) {
    RRCouponStatus["Active"] = "active";
    RRCouponStatus["Activated"] = "activated";
    RRCouponStatus["Used"] = "used";
    RRCouponStatus["Expired"] = "expired";
    RRCouponStatus["Cancelled"] = "cancelled";
})(RRCouponStatus = exports.RRCouponStatus || (exports.RRCouponStatus = {}));
var RRCouponBlockReason;
(function (RRCouponBlockReason) {
    RRCouponBlockReason["AlreadyUsed"] = "already_used";
    RRCouponBlockReason["Expired"] = "expired";
    RRCouponBlockReason["InvalidStatus"] = "invalid_status";
})(RRCouponBlockReason = exports.RRCouponBlockReason || (exports.RRCouponBlockReason = {}));
//# sourceMappingURL=Order.js.map